var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1290","data-name":"Path 1290","d":"M1855.6,465.667a10,10,0,1,0,10,10A10.012,10.012,0,0,0,1855.6,465.667Zm0,18.889a8.889,8.889,0,0,1-.535-17.761v10.3l-2.353-2.343-.784.787,3.7,3.688,3.641-3.673-.789-.782-2.308,2.329V466.8a8.888,8.888,0,0,1-.575,17.758Zm-4.27-3.063h8.54v-1.111h-8.54Z","transform":"translate(-1845.601 -465.667)","fill":"#fff"}));
}

Download.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Download;

Download.default = Download;
